import { Heading, Link } from '@primer/react';
import { LinkExternalIcon } from '@primer/octicons-react';
import FormsLayout from '~/src/layouts/forms-layout';
import * as React from 'react';
export default {
  Heading,
  Link,
  LinkExternalIcon,
  FormsLayout,
  React
};